module.exports = __webpack_public_path__ + "static/img/OTTAWA_PAINT.f9e2ab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/OTTAWA_PAINT.jpg
// module id = 3MoF
// module chunks = 0